import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=3131fc09&lang=pug&"
import script from "./BannerItem.vue?vue&type=script&lang=ts&"
export * from "./BannerItem.vue?vue&type=script&lang=ts&"
import style0 from "./BannerItem.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports